module.exports = __webpack_public_path__ + "f007dd4541db4ce665c0fabbacf006f4.pdf";